import styled from '@emotion/styled';
import { Button, Input, Modal, notification, Table } from 'antd';
import moment from 'moment';
import { useState } from 'react';
import { FaDollarSign } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../../entities/ConnectedUserEntity';
import { TransactionEntity } from '../../../../../entities/transaction.entity';
import { PRIMARY } from '../../../../../shared/colors';
import { formatNum } from '../../../../../shared/constants';
import { finalizeTransaction } from '../network/network';

const Container = styled.div`
  color: white;
  padding: 5px;
  margin-bottom: 5px;
  font-family: Poppins-R;

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  max-height: calc(100vh - 575px);
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0.5vw;
  }

  &::-webkit-scrollbar-thumb {
    background-image: linear-gradient(to bottom, #eceff1, #eceff1);
    border-radius: 10px;
  }
`;

export const Transactions = ({ transactions }: { transactions: any[] }) => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTransact, setSelectedTransact] = useState<TransactionEntity>();
  const [numTelephone, setNumTelephone] = useState('+2376');
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;

  const finalize = () => {
    setIsLoading(true);

    let schema = '';
    let codeClient = selectedTransact?.detenteur.code_referent;
    if (connectedUser.partenaire.code_referent === codeClient) {
      schema = 'VENTCP';
    } else {
      schema = 'VENTCT';
    }

    const dataToCreate = {
      schema,
      userId: connectedUser.id,
      montant: Math.ceil(
        Number(selectedTransact?.qte) * Number(selectedTransact?.prixNominale) +
          Number(selectedTransact?.couponCouruPayer) +
          Number(selectedTransact?.commIntermediation) +
          Number(selectedTransact?.commConservation) +
          Number(selectedTransact?.commDroitGarde) +
          Number(selectedTransact?.commBrokerage),
      ),
      telephone: numTelephone,
    };

    finalizeTransaction(selectedTransact?.id as string, dataToCreate)
      .then(({ statusCode, data }) => {
        if (statusCode.toString()[0] === '2') {
          notification.info({
            message: 'Statut',
            description: data.message,
          });
          setShowModal(false);
        } else {
          notification.error({
            message: 'Erreur',
            description: data.message,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  const COLUMNS = [
    {
      title: 'Pays',
      render: (cell: any, row: TransactionEntity) => row.bond.pays,
    },
    {
      title: 'CODE',
      render: (cell: any, row: TransactionEntity) => row.bond.code,
    },
    {
      title: 'Detenteur',
      render: (cell: any, row: TransactionEntity) =>
        row.detenteur.code_referent,
    },
    {
      title: 'Opération',
      dataIndex: 'typeOperation',
    },
    {
      title: 'Date Ope',
      dataIndex: 'dateOperation',
      render: (cell: any) => `${moment(cell).format('DD/MM/YYYY')}`,
    },
    {
      title: 'Qte',
      dataIndex: 'qte',
    },
    {
      title: 'Coupon',
      dataIndex: 'tauxInteret',
    },
    {
      title: 'Décote',
      dataIndex: 'decote',
    },
    {
      title: 'Prix total',
      render: (cell: any, row: TransactionEntity) =>
        `${formatNum(row.qte * row.prixNominale)}`,
    },
    {
      title: 'Net',
      render: (cell: any, row: TransactionEntity) =>
        `${formatNum(
          Math.ceil(
            Number(row.qte) * Number(row.prixNominale) +
              Number(row.couponCouruPayer) +
              Number(row.commIntermediation) +
              Number(row.commConservation) +
              Number(row.commDroitGarde) +
              Number(row.commBrokerage),
          ),
        )}`,
    },
    {
      title: 'Statut',
      dataIndex: 'statut',
    },
    {
      title: 'Action',
      render: (cell: any, row: TransactionEntity) => (
        <Button
          icon={<FaDollarSign style={{ color: 'white', marginBottom: -2 }} />}
          style={{
            backgroundColor: 'transparent',
            borderRadius: 20,
            zoom: 0.8,
          }}
          onClick={() => {
            setSelectedTransact(row);
            setShowModal(true);
          }}
          disabled={
            row.statut === 'finalisé'
              ? true
              : row.typeOperation === 'ACHAT'
              ? false
              : true
          }
        />
      ),
    },
  ];

  return (
    <Container>
      {transactions.length === 0 ? (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          Aucune transaction n'est disponible...
        </div>
      ) : (
        <Table
          columns={COLUMNS}
          dataSource={transactions}
          rowClassName={(row, index) =>
            index % 2 === 0 ? 'even-row' : 'odd-row'
          }
          size='small'
          style={{ zoom: 0.75 }}
          pagination={false}
        />
      )}

      <Modal
        className='dark-modal'
        open={showModal}
        title='Finaliser la transaction'
        onCancel={() => setShowModal(false)}
        footer={[
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              onClick={() => setShowModal(false)}
              style={{ borderRadius: 20 }}
            >
              Fermer
            </Button>
            <Button
              className='butt'
              loading={isLoading}
              style={{ borderRadius: 20 }}
              onClick={finalize}
            >
              Finaliser
            </Button>
          </div>,
        ]}
      >
        {selectedTransact && (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <p>Montant de la transcation :</p>
              <p>
                Numéro de téléphone{' '}
                <i style={{ color: 'gray', fontSize: 12 }}>(OM/MoMo)</i> :
              </p>
            </div>
            <div>
              <p style={{ fontWeight: 'bold', color: 'green' }}>
                {formatNum(
                  Math.ceil(
                    Number(selectedTransact.qte) *
                      Number(selectedTransact.prixNominale) +
                      Number(selectedTransact.couponCouruPayer) +
                      Number(selectedTransact.commIntermediation) +
                      Number(selectedTransact.commConservation) +
                      Number(selectedTransact.commDroitGarde) +
                      Number(selectedTransact.commBrokerage),
                  ),
                )}{' '}
                XAF
              </p>
              <Input
                placeholder='numéro téléphone'
                value={numTelephone}
                onChange={(e) => setNumTelephone(e.target.value)}
              />
            </div>
          </div>
        )}
      </Modal>
    </Container>
  );
};
